module.exports = __webpack_public_path__ + "style/ckm-style/images/icon_arrow_red.svg?263c362707e7ab8389f418f415d57f70";